var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-header',{ref:"navHeader"}),_c('el-scrollbar',{ref:"appMain",staticClass:"app_main"},[_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('keep-alive',{attrs:{"include":_vm.cachedViews}},[_c('router-view',{key:_vm.key})],1)],1)],1),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }